import React from 'react';
import './TrustedBySection.css';
import WhyCognitva from './WhyCognitva';
import siteConfig from '../../configuration/siteConfiguration';

const baseImageUrl = `${siteConfig.assetBaseUrl}/certificates`;

const line1Style = {
  color: '#072C55',
  fontVariantNumeric: 'lining-nums proportional-nums',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Author',
  fontSize: '11px',
  fontStyle: 'normal',
  fontWeight: 800,
  lineHeight: "19.2px"
};

const line2Style = {
  color: '#3D5672',
  fontFeatureSettings: "'liga' off, 'clig' off",
  fontFamily: 'Author',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 596,
  lineHeight: "18px" /* 142.857% */
}

const SimpleTwoLinerContent = ({ line1, line2 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <div style={line1Style}>{line1}</div>
    <div style={line2Style}>{line2}</div>
  </div>
);

const GapContent = ({ length }) => (
  <div style={{ width: length, fontSize: '11px', lineHeight: "18px" }}>&nbsp;</div>
);
const companies = [
  { content: (<img src={`${baseImageUrl}/anvesana-supported.jpg`} alt="Anvesana Supported Certificate" />) },
  { content: (<img src={`${baseImageUrl}/nvidia-incepted.jpg`} alt="Anvesana Supported Certificate" />) },
  { content: <SimpleTwoLinerContent line1="Ideonix" line2="Live" /> },
  { content: <SimpleTwoLinerContent line1="5 Patents" line2="submitted" /> },
  { content: <SimpleTwoLinerContent line1="Copyrights" line2="registered" /> },
  { content: <SimpleTwoLinerContent line1="Winner of Bharath Startup Grand Challenge 2026" line2="(Marquee Initiative of DPIIT Startup India - JK Cement) among 2000+ startups" /> },
  { content: <GapContent length="250px" /> },

];

const TrustedBySection = () => {
  const duplicatedCompanies = [...companies, ...companies];

  return (
    <div className="trusted-by-section">
      <div className="trusted-by-text">
        Early Traction Across Health Care & Manufacturing
      </div>
      <div className="trusted-by-container">
        <div className="trusted-by-logos-row">
          {duplicatedCompanies.map((company, idx) => (
            <React.Fragment key={`${company.name}-${idx}`}>
              <div className="trusted-by-logo">
                {company.content ? company.content : <>
                  {company.icon && <span className="trusted-by-logo-icon" style={company?.styles}>{company.icon}</span>}
                  {company.name && <span className="trusted-by-logo-name">{company.name}</span>}
                </>}
              </div>
              {idx < duplicatedCompanies.length - 1 && <img src="/images/separator.svg" alt="separator" className="trusted-by-separator" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>

  );
};

export default TrustedBySection;